// Phase 0093-B0 — HR default-config admin API client.
import apiClient from '@/shared/api/client'

export interface SectionSummary {
  section_code: string
  label: string
  critical: boolean
  total: number
  seeded: number
  admin_modified: number
  active: number
  status: 'EMPTY' | 'ACTIVE' | 'INACTIVE'
}

export interface SectionRow {
  id: string
  code: string | null
  label: string | null
  active: boolean
  system_seeded: boolean
  admin_modified_at: string | null
  factory_version: number | null
  last_seeded_at: string | null
}

export interface CompletenessIssue {
  section: string
  level: 'BLOCKED' | 'WARNING'
  message: string
}

export interface CompletenessReport {
  overall_status: 'READY' | 'WARNING' | 'BLOCKED'
  sections: SectionSummary[]
  issues: CompletenessIssue[]
}

const P = '/hr/default-config'

export const defaultConfigApi = {
  sections: async (): Promise<SectionSummary[]> =>
    (await apiClient.get<SectionSummary[]>(`${P}/sections`)).data,
  rows: async (section: string): Promise<SectionRow[]> =>
    (await apiClient.get<SectionRow[]>(`${P}/sections/${section}`)).data,
  completeness: async (): Promise<CompletenessReport> =>
    (await apiClient.get<CompletenessReport>(`${P}/completeness`)).data,
  markModified: async (section: string, rowId: string) =>
    (await apiClient.post<SectionRow>(
      `${P}/sections/${section}/rows/${rowId}/mark-modified`)).data,
  resetToFactory: async (section: string, rowId: string) =>
    (await apiClient.post<SectionRow>(
      `${P}/sections/${section}/rows/${rowId}/reset-to-factory`)).data,
  reseed: async () =>
    (await apiClient.post<Record<string, Record<string, number>>>(
      `${P}/reseed`)).data,
}
